
import { Component, ElementRef, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { waitSeconds } from '@reflact/tsutil';
import { HintComponent } from '@shared-angular/components/hint/hint.component';
import { ToastrService } from '@shared-angular/services/toastr.service';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { ButtonModule } from 'primeng/button';
import { CardModule } from 'primeng/card';
import { InputTextModule } from 'primeng/inputtext';
import { MessageModule } from 'primeng/message';
import { TagModule } from "primeng/tag";
import { BotChatDialogComponent } from 'src/app/shared/components/ai-bot/utils/bot-chat-dialog/bot-chat-dialog.component';
import { FormForBooleanComponent } from 'src/app/shared/components/ai-bot/utils/form-for-boolean/form-for-boolean.component';
import { BotMessagesService } from 'src/app/shared/services/bot-messages.service';
import { BotService } from 'src/app/shared/services/bot.service';
import { RouteShareService } from 'src/app/shared/services/route-share.service';
import { ManualLinkComponent } from "../../../../../../shared/components/rag-admin/manual-link/manual-link.component";
import { BotMemoryBrowserFilterComponent } from './bot-memory-browser-filter/bot-memory-browser-filter.component';

@Component({
  templateUrl: './memory-tab.component.html',
  styleUrl: './memory-tab.component.scss',
  imports: [
    NgSelectModule,
    FormsModule,
    BotChatDialogComponent,
    BotMemoryBrowserFilterComponent,
    FormForBooleanComponent,
    HintComponent,
    ManualLinkComponent,
    CardModule,
    MessageModule,
    ButtonModule,
    InputTextModule,
    TagModule
  ],
  providers: [BsModalService]
})
export class MemoryTabComponent implements OnInit {
  @ViewChild('myDialog') public myDialog?: BotChatDialogComponent & HTMLElement;
  @ViewChild('deleteFilter') public deleteFilter!: BotMemoryBrowserFilterComponent;
  @ViewChild('messageFilter') public messageFilter!: BotMemoryBrowserFilterComponent;
  @ViewChild('chatScrollContainer') public chatScrollContainer?: ElementRef<HTMLDivElement>;
  public promptInput: string = '';
  public isThinking = false;
  public bsModalRef?: BsModalRef;
  public memoryActive = $localize`:@@memory-active:Gedächtnis aktiv`;


  constructor(
    private toastr: ToastrService,
    private modalService: BsModalService,
    private bot: BotService,
    public rss: RouteShareService,
    private botMessages: BotMessagesService
  ) { }

  public ngOnInit() {
    this.botMessages.addMessage({
      item_id: '',
      _id: "",
      context: {
        botid: this.rss.botConfig._id,
        user: ""
      },
      threadId: "",
      supervisorEnabled: this.rss.botConfig.supervisorEnabled,
      memoryEnabled: this.rss.botConfig.memoryEnabled,
      created: new Date(),
      role: 'assistant',
      content: [{
        text: $localize`:@@memory-browser-initialmessage:<p>Hallo, ich bin das Gedächtnis von <i>${this.rss.botConfig.name}</i>.</p><p>Ich beantworte deine Fragen rund um mein gesammeltes Wissen.<br>Mit den Filtern etwas weiter oben kannst du spezifizieren, auf welches Wissen ich zugreifen soll.</p>`,
        type: 'text'
      }]
    });
    void this.scrollChatToBottom();
  }

  public async scrollChatToBottom() {
    await waitSeconds(0.1);
    const container = this.chatScrollContainer?.nativeElement;
    if (container) {
      container.scrollTo({ top: container.scrollHeight, behavior: 'smooth' });
    }
  }

  public getBotConfig() {
    return { ...this.rss.botConfig };
  }

  public onKey(e: KeyboardEvent) {
    if (e.key === "Enter") {
      if (!e.shiftKey) {
        void this.add();
      }
    }
  }

  public async add() {
    this.isThinking = true;
    this.botMessages.addMessage({
      item_id: '',
      _id: "",
      context: {
        botid: this.rss.botConfig._id,
        user: ""
      },
      threadId: "",
      memoryEnabled: this.rss.botConfig.memoryEnabled,
      supervisorEnabled: this.rss.botConfig.supervisorEnabled,
      created: new Date(),
      role: 'user',
      content: [{ text: this.promptInput, type: 'text' }]
    });
    void this.bot.scrollDown();
    void this.scrollChatToBottom();
    this.promptInput = '';
    const result = await this.bot.askSummary(this.rss.botConfig._id, {
      prompts: this.botMessages.getMessages(),
      fromDate: this.messageFilter.multiCopyFromDate,
      toDate: this.messageFilter.multiCopyToDate
    });
    if (result.choices[0]) {
      const msg = result.choices[0].message;
      this.botMessages.addMessage({
        item_id: '',
        _id: "",
        context: {
          botid: this.rss.botConfig._id,
          user: ""
        },
        memoryEnabled: this.rss.botConfig.memoryEnabled,
        supervisorEnabled: this.rss.botConfig.supervisorEnabled,
        threadId: "",
        created: new Date(),
        role: msg.role,
        bypass: false,
        content: [{ text: msg.content, type: 'text' }]
      });
    }
    void this.bot.scrollDown();
    void this.scrollChatToBottom();
    this.isThinking = false;
  }

  public openConfirmDeleteHistory(template: TemplateRef<void>) {
    this.bsModalRef = this.modalService.show(template, { class: 'modal-lg' });
  }

  public async deleteHistory() {
    const result = await this.bot.deleteHistoryItems(this.rss.botConfig._id, {
      fromDate: this.deleteFilter.multiCopyFromDate,
      toDate: this.deleteFilter.multiCopyToDate
    });

    this.modalService.hide(this.bsModalRef?.id);
    this.toastr.success("HISTORY_DELETED", `${result.deletedCount.toString()} History-Einträge wurden gelöscht`);
    void this.deleteFilter.updateDeleteCount();
  }
}
